export default "__VITE_ASSET__CT4iet5p__"